import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2f6db40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-c-hub-gallery-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "hd-c-hub-gallery-content__controls" }
const _hoisted_4 = { class: "hd-c-hub-gallery-content__view" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_icon_button = _resolveComponent("base-icon-button")!
  const _component_covid_gallery_content_grid = _resolveComponent("covid-gallery-content-grid")!
  const _component_covid_gallery_content_no_data = _resolveComponent("covid-gallery-content-no-data")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.sectionId && _ctx.galleryData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_base_image_svg, {
              class: _normalizeClass(["hd-c-hub-gallery-content__controls-reactive", { 'is-active': _ctx.showReactive }]),
              onClick: _ctx.toggleReactiveSlides,
              source: require('!html-loader!../assets/icons/reactive.svg')
            }, null, 8, ["class", "onClick", "source"]),
            _createVNode(_component_base_icon_button, {
              callback: _ctx.makeViewActive,
              callbackString: "grid",
              iconSource: require('!html-loader!../assets/icons/grid-view.svg')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lyra_asset, { "asset-key": "gallery-grid-view" })
              ]),
              _: 1
            }, 8, ["callback", "iconSource"]),
            _createVNode(_component_base_icon_button, {
              callback: _ctx.makeViewActive,
              callbackString: "list",
              iconSource: require('!html-loader!../assets/icons/list-view.svg')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lyra_asset, { "asset-key": "gallery-list-view" })
              ]),
              _: 1
            }, 8, ["callback", "iconSource"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleryData, (datum, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "hd-c-hub-gallery-content__view-category"
              }, [
                (datum.hasSection)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([
							'hd-c-hub-gallery-content__view-category-section',
							{ 'is-hidden': _ctx.hiddenSections.includes(datum.section) }
						]),
                      onClick: ($event: any) => (_ctx.toggleSectionHiddenView(datum.section))
                    }, [
                      _createVNode(_component_base_image_svg, {
                        source: require('!html-loader!../assets/icons/chevron-up.svg')
                      }, null, 8, ["source"]),
                      _createVNode(_component_lyra_asset, {
                        "asset-key": `category-${datum.section}-title`
                      }, null, 8, ["asset-key"])
                    ], 10, _hoisted_5))
                  : _createCommentVNode("", true),
                _createVNode(_Transition, { name: "fade-up" }, {
                  default: _withCtx(() => [
                    (!_ctx.hiddenSections.includes(datum.section))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_covid_gallery_content_grid, {
                            datum: datum.records,
                            section: datum.section,
                            view: _ctx.activeView
                          }, null, 8, ["datum", "section", "view"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createBlock(_component_covid_gallery_content_no_data, { key: 1 }))
  ]))
}